import { render } from "./ModalwindowView.vue?vue&type=template&id=0bd9c63d&scoped=true"
import script from "./ModalwindowView.vue?vue&type=script&lang=js"
export * from "./ModalwindowView.vue?vue&type=script&lang=js"

import "./ModalwindowView.vue?vue&type=style&index=0&id=0bd9c63d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd9c63d"]])

export default __exports__